import { Component, OnInit, inject, signal } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CalComWidgetComponent } from '../../components/cal-com-widget/cal-com-widget.component';
import { CiiBadgeComponent } from '../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule, CalComWidgetComponent, CiiBadgeComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent implements OnInit {
  formData = {
    name: '',
    email: '',
    message: ''
  };
  status = signal({ type: '', message: '' });
  isSubmitting = signal(false);

  private http = inject(HttpClient);
  private titleService = inject(Title);
  private metaService = inject(Meta);

  ngOnInit() {
    this.titleService.setTitle("Contactez Mesh Box : Agence Web à Paris & Châteauroux — Expert CII");
    this.metaService.updateTag({ name: 'description', content: "Un projet de développement Node.js, Angular ou une application à moderniser ? Contactez nos experts à Paris ou Châteauroux pour un devis gratuit et éligible au CII." });
  }

  handleSubmit() {
    if (this.isSubmitting()) return;

    this.isSubmitting.set(true);
    this.status.set({ type: '', message: '' });

    const apiUrl = 'https://api.mesh-box.fr/api/contact';

    this.http.post<any>(apiUrl, this.formData).subscribe({
      next: (res) => {
        this.status.set({ type: 'success', message: 'Votre message a été envoyé avec succès. Nous vous répondrons sous 24h.' });
        this.formData = { name: '', email: '', message: '' };
        this.isSubmitting.set(false);
      },
      error: (err) => {
        console.error('Contact submission error:', err);
        this.status.set({
          type: 'error',
          message: err.error?.error || "Désolé, une erreur est survenue lors de l'envoi. Vous pouvez nous contacter directement à contact@mesh-box.fr"
        });
        this.isSubmitting.set(false);
      }
    });
  }
}
